import { Component, OnInit } from '@angular/core';
import { DatePipe, DecimalPipe } from "@angular/common";
import { saveAs } from 'file-saver';
import { DownloadFileService } from '../../shared/services/download-file.service';
import { ApiService } from '../../shared/services/api.service';
import { Urls } from '../../utils/urls';
import { CommonDataService } from "../../shared/services/common-data.service";
import { ExportExcelService } from "../../shared/services/export-excel.service";
import * as moment from 'moment';
import { PAGE_SIZE, Please_select_From_Date_and_To_Date} from "@root/app.constant";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss']
})
export class DownloadsComponent implements OnInit {
  activeTopicId = 0;

  topicList = [];

  topicListMap:{[key:string]: any[]} ={};
  
  data = [];

  assetCheck : boolean = false;

  today = new Date();

  range : { start: Date, end: Date} = { start : null, end : null};

  pageSize:number = PAGE_SIZE;

  pageIndex:number = 0;

  activePageDataChunk = [];

  digitalFactsheetData=[];

  digitalFactSheetTitle = "Digital Factsheet";

  constructor(public downloadFileService: DownloadFileService, 
              private apiService: ApiService, 
              private commonDataService: CommonDataService,
              public exportExcel: ExportExcelService,
              private toastr: ToastrService,) { }

  ngOnInit() {
    this.getDownloadFiles();
    this.scrollTop();
    this.readDigitalFactsheet();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getDownloadFiles = () => {
    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(Urls.getDocumentsByType, {type : 'downloads'}).subscribe(
      response => {
        if (response.data.documentList){
          this.topicList = response.data.documentList;
          this.setDigitalFactSheetAsTopic();
          this.activePageDataChunk = this.topicList[0].returnList.slice(0, this.pageSize);
          this.commonDataService.loaderStatus.next(false);
        }
      },
      error => {
        this.commonDataService.loaderStatus.next(false);
      }
    )
  }

  setActiveTopic = (id) => {
    this.assetCheck = false;
    this.activeTopicId = id;
    this.activePageDataChunk = this.topicList[id].returnList.slice(0, this.pageSize);
  }

  viewFile = (path) => {
    window.open(path, '_blank');

  }

  public downloadFile(path, name){
    const fileName = path.split("/").pop();
    this.downloadFileService.export(path).subscribe(data => saveAs(data, fileName));
  }

  public assetAllocation(event: string){
   if(event === 'true'){
    this.assetCheck = true;
    this.readAssetAllocationData();
   }else{
    this.assetCheck = false;
   }
  }

  public readAssetAllocationData(){
    this.commonDataService.loaderStatus.next(true);
    const obj = { "fromDate": "",
                  "toDate" : ""
                }
    this.apiService.postData(Urls.readAssetAllocation, obj).subscribe(
      response => {
      this.data = response.data.list;
      this.commonDataService.loaderStatus.next(false);
      },
      error => {
        this.commonDataService.loaderStatus.next(false);
      }
    )
  }

  public readDigitalFactsheet(){
    this.commonDataService.loaderStatus.next(true);
    const obj = { "year": ""}
    this.apiService.postData(Urls.readDigitalFactsheet, obj).subscribe(
      response => {
      if(response.status === 0){
          this.digitalFactsheetData =  response.data.digitalFactsheetReturnValue;
      }
      this.commonDataService.loaderStatus.next(false);
      },
      error => {
        this.commonDataService.loaderStatus.next(false);
      }
    )
  }

  public setDigitalFactSheetAsTopic(){
   let factsheetIndex = 0; 
   for(let i=0; i<this.topicList.length; i++){
     const topic = this.topicList[i];
        if(topic.topic.toLowerCase() === "factsheet"){
          factsheetIndex = i;
          break;
        }
    }

    const digitalFactSheetTopic= {
      topic : this.digitalFactSheetTitle,
      returnList : this.digitalFactsheetData
    }
    this.topicList.splice(factsheetIndex+1, 0, digitalFactSheetTopic);
  }
 
  public downloadAssestAllocation(){
    const data = this.getFormatedData();
    this.exportExcel.exportAsExcelFile(data, `Assest_Allocation`)
  }

  private getFormatedData(): any[] {

    const datePipe = new DatePipe("en-US");
    const decimalPipe = new DecimalPipe("en-US");
    const data = JSON.parse(JSON.stringify(this.data));
    for (const row of data) {
      if (row.date) {
        row.date = datePipe.transform(row.date, "dd-MMM-yyyy");
      }
      if (row.netequity) {
        const netequity = decimalPipe.transform(row.netequity, "1.2-2");
        row.netequity = `${netequity}%`;
      }
      if (row.arbitrage) {
        const arbitrage = decimalPipe.transform(row.arbitrage, "1.2-2");
        row.arbitrage = `${arbitrage}%`;
      }
      if (row.debtandcash) {
        const debtandcash = decimalPipe.transform(row.debtandcash, "1.2-2");
        row.debtandcash = `${debtandcash}%`;
      }
    }
    return data;
  }

  public dateRangeSearch(){
    if(this.range.start === null || this.range.end === null){
      this.toastr.error(Please_select_From_Date_and_To_Date)
    }else{
      const obj = {
        fromDate : moment(this.range.start).format("YYYY-MM-DD"),
        toDate :  moment(this.range.end).format("YYYY-MM-DD")
      }
      this.commonDataService.loaderStatus.next(true);
      this.apiService.postData(Urls.readAssetAllocation, obj).subscribe(
        response => {
          this.data = response.data.list
          this.commonDataService.loaderStatus.next(false);
          this.resetDateRange()
        },
        error => {
          this.commonDataService.loaderStatus.next(false);
        }
      )
    }
  }

  onPageChanged(e, data) {
    let firstCut = e.pageIndex * e.pageSize;
    let secondCut = firstCut + e.pageSize;
    this.activePageDataChunk = data.slice(firstCut, secondCut);
  }

  public resetDateRange(){
    this.range.start = null;
    this.range.end = null;
  }
}
